export default __webpack_public_path__ + "images/lev_dd4a33.svg";